export default __webpack_public_path__ + "static/media/arrow-right.aec1b6f9.svg";